// extracted by mini-css-extract-plugin
export var phone = "_16-0";
export var phoneDragging = "_16-1";